import { render, staticRenderFns } from "./groupManaget.vue?vue&type=template&id=0412f7f4&scoped=true&"
import script from "./groupManaget.vue?vue&type=script&lang=js&"
export * from "./groupManaget.vue?vue&type=script&lang=js&"
import style0 from "./groupManaget.vue?vue&type=style&index=0&id=0412f7f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412f7f4",
  null
  
)

export default component.exports